<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content>
  <p>{{ message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ cancelButtonText }}</button>
  <button mat-flat-button [color]="confirmButtonColor" (click)="confirm()">{{ confirmButtonText }}</button>
</div>
